
//     Eteration.js 1.1.0
//     (c) 2014 Eteration A.S.
//     http://eteration.com

(function(root, factory) {

	if (typeof define === 'function' && define.amd) {
		define('eteration/eteration',[ 'jquery', 'exports', 'knockout', 'bootstrap','application', 'eteration/eteration-ajax', 'eteration/eteration-urlparser','eteration/eteration-base' ], function($, exports, ko, b,a, etrAjax, urlParser,etrBase) {
			root.Eteration = factory(root, exports, $, ko, b,a, etrAjax, urlParser,etrBase);
		});

	} else {
		root.Eteration = factory(root, {}, (root.jQuery || root.Zepto || root.ender || root.$), root.ko, root.b, root.a);
	}

}(this, function(root, Eteration, $, ko, b, a,etrAjax, urlParser,etrBase) {


	var root = this;

	var previousEteration = root.Eteration;

	Eteration.VERSION = '0.0.1.etr';


	Eteration.$ = root.jQuery || root.Zepto || root.ender || root.$;


	Eteration.noConflict = function() {
		root.Eteration = previousEteration;
		return this;
	};



	Eteration.loadStaticFragment = function(settings) {
		etrBase.loadStaticFragment(settings);
	};
	
	
	Eteration.toCDNPATH = function(url) {
		if(window.cdnDomain){
			url = window.cdnDomain+ url;
		}
		return url;
	};

}));
